/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonDocumentApprovalListItemViewModel } from "../types/PersonDocumentApprovalListItemViewModel.ts";

export const personDocumentApprovalListItemViewModelSchema = z.object({
  personId: z.optional(z.number().int().describe("ID da pessoa (aluno).")),
  personName: z.string().describe("Nome completo do aluno.").nullish(),
  courseRegistrationId: z.optional(
    z.number().int().describe("ID da matrícula."),
  ),
  classStudentText: z.string().describe("Descrição da turma.").nullish(),
  enrollmentStatus: z.optional(
    z
      .number()
      .int()
      .describe(
        "Status da matrícula. Enum EEnrollmentStatus: `1` = PaymentSelection, `2` = PaymentPending, `3` = ApprovalPending, `4` = Approved, `5` = Activating, `6` = Active, `7` = Transferred, `8` = TransferredInRegistration, `9` = Canceled, `10` = CanceledInRegistration, `11` = Rejected, `12` = FinishedWithPendencies, `13` = Finished, `14` = FinishedWithMonograph, `15` = FinishedWithCertificate, `16` = Blocked.",
      ),
  ),
  enrollmentStatusText: z
    .string()
    .describe("Descrição do status da matrícula (pt-BR).")
    .nullish(),
  documentationStatus: z
    .number()
    .int()
    .describe(
      "Status geral da documentação. Opcional. Enum EDocumentationStatus: `0` = Pending, `1` = Approved, `2` = Rejected, `3` = ApprovedTemporary.",
    )
    .nullish(),
  documentationStatusText: z
    .string()
    .describe("Descrição do status geral da documentação (pt-BR). Opcional.")
    .nullish(),
  associatedCompanyName: z
    .string()
    .describe("Nome da empresa associada do aluno; vazio quando não há.")
    .nullish(),
  scholarshipType: z
    .string()
    .describe("Tipo de bolsa do financeiro principal; vazio quando não há.")
    .nullish(),
  firstDocDate: z.optional(
    z
      .string()
      .datetime()
      .describe(
        "Data do primeiro envio de documento; data atual quando o aluno ainda não enviou.",
      ),
  ),
}) as unknown as ToZod<PersonDocumentApprovalListItemViewModel>;
